import React, { useEffect, useState } from 'react';
import Menu from "../../comum/Menu/menu.jsx";
import Footer from "../../comum/Footer";
import { api } from '../../services/api';
import Swal from 'sweetalert2';
import { FaCreditCard, FaCalendarAlt, FaChevronDown, FaChevronUp, FaReceipt } from 'react-icons/fa';
import './convenio.css';

const Convenio = () => {
    const chapa = localStorage.getItem("chapa");
    const [saldo, setSaldo] = useState(null);
    const [periodos, setPeriodos] = useState([]);
    const [detalhesVisiveis, setDetalhesVisiveis] = useState({});

    const formatCurrency = (val) => {
        const amount = Number(val) || 0;
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(amount);
    };

    const decodificarBase64 = (textoBase64) => {
        try {
            return atob(textoBase64);
        } catch (err) {
            console.error('Erro ao decodificar Base64:', err);
            return '';
        }
    };

    useEffect(() => {
        const carregarDados = async () => {
            try {
                const resSaldo = await api.get(`/aeflor/convenio/${chapa}`);
                setSaldo(resSaldo.data);
                const resPeriodos = await api.get(`/aeflor/convenio/${chapa}/periodo`);
                setPeriodos(resPeriodos.data);
            } catch (err) {
                console.error("Erro ao carregar dados do convênio", err);
                Swal.fire("Erro", "Não foi possível carregar os dados do convênio.", "error");
            }
        };

        if (chapa) {
            carregarDados();
        }
    }, [chapa]);

    const toggleDetalhes = async (index, periodo) => {
        const visiveis = { ...detalhesVisiveis };

        if (visiveis[index]) {
            delete visiveis[index];
        } else {
            try {
                const res = await api.get(`/aeflor/convenio/${chapa}/consumo/${periodo}`);
                visiveis[index] = res.data;
            } catch (err) {
                console.error("Erro ao carregar compras do período", err);
                Swal.fire("Atenção", "Sem registros de compra no período selecionado.", "warning");
                return;
            }
        }

        setDetalhesVisiveis(visiveis);
    };

    return (
        <div className="bg-light w-100 min-vh-100" style={{ paddingTop: '80px' }}>
            <Menu modulo="ARBOR" />

            <div
                className="container py-3 px-2 px-md-4"
                style={{
                    display: 'block',
                    margin: '0 auto !important',
                    maxWidth: '1140px',
                    float: 'none',
                    clear: 'both'
                }}
            >
                <div className="d-flex align-items-center mb-3">
                    <FaCreditCard className="me-2 text-danger fs-4" />
                    <h4 className="fw-bold text-dark m-0">Convênio AEFLOR</h4>
                </div>

                {/* PAINEL DE SALDO E METRICAS */}
                {saldo && (
                    <div className="card shadow-sm border-0 mb-4 rounded-4 overflow-hidden bg-white">
                        {saldo.sucesso === 'B' && saldo.motivobloqueio !== "" ? (
                            <div className="card-body bg-danger text-white text-center py-3">
                                <h6 className="m-0 fw-bold">
                                    ⚠️ Convênio Bloqueado: {decodificarBase64(saldo.motivobloqueio)}
                                </h6>
                            </div>
                        ) : (
                            <div className="card-body p-3 p-md-4">
                                <div className="row text-center g-3">

                                    {/* Limite Total */}
                                    <div className="col-12 col-md-4">
                                        <div className="p-3 border rounded-3 bg-light d-flex flex-column justify-content-between h-100">
                                            <div>
                                                <small className="text-muted d-block text-uppercase fw-bold label-metric">
                                                    Limite Total
                                                </small>
                                                <span className="fs-4 fw-bold text-dark d-block my-1">
                                                    {formatCurrency(saldo.limite)}
                                                </span>
                                            </div>
                                            <div className="pt-2 border-top text-center mt-2">
                                                <small className="fw-semibold text-secondary me-1">Data de Corte:</small>
                                                <span className="badge bg-secondary text-white">{saldo.datacorte || 'N/A'}</span>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Total Utilizado */}
                                    <div className="col-12 col-md-4">
                                        <div className="p-3 border rounded-3 bg-light d-flex flex-column justify-content-between h-100">
                                            <div>
                                                <small className="text-muted d-block text-uppercase fw-bold label-metric">
                                                    Total Utilizado
                                                </small>
                                                <span className="fs-4 fw-bold text-danger my-1 d-block">
                                                    {formatCurrency(saldo.usado)}
                                                </span>
                                            </div>
                                            <div className="pt-2 border-top text-center mt-2">
                                                <small className="text-muted small">Consumo no período ativo</small>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Saldo Disponível */}
                                    <div className="col-12 col-md-4">
                                        <div className="p-3 rounded-3 text-white d-flex flex-column justify-content-between h-100 card-saldo-degrade">
                                            <div>
                                                <small className="text-white-50 d-block text-uppercase fw-bold label-metric">
                                                    Saldo Disponível
                                                </small>
                                                <span className="fs-3 fw-bold text-white d-block my-1">
                                                    {formatCurrency(saldo.limite - saldo.usado)}
                                                </span>
                                            </div>
                                            <div className="pt-2 border-top border-light border-opacity-25 text-center mt-2">
                                                <small className="fw-semibold text-white me-1">Data de Pagamento:</small>
                                                <span className="badge bg-white text-dark fw-bold">{saldo.datapgto || 'N/A'}</span>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        )}
                    </div>
                )}

                {/* HISTÓRICO DE PERÍODOS */}
                <div className="d-flex align-items-center mb-3">
                    <FaCalendarAlt className="me-2 text-secondary" />
                    <h6 className="fw-bold mb-0 text-secondary">Histórico de Períodos</h6>
                </div>

                {periodos.length === 0 ? (
                    <div className="text-center py-4 text-muted bg-white rounded-3 shadow-sm border">
                        Nenhum período encontrado.
                    </div>
                ) : (
                    periodos.map((p, idx) => (
                        <div 
                            key={idx} 
                            className="card mb-3 overflow-hidden"
                            style={{
                                backgroundColor: '#f8f9fa',
                                border: '1.5px solid #e0e0e0',
                                borderLeft: '6px solid #a91b0d',
                                borderRadius: '12px',
                                boxShadow: '0 2px 6px rgba(0,0,0,0.04)'
                            }}
                        >
                            <div
                                className="p-3 d-flex justify-content-between align-items-center cursor-pointer"
                                onClick={() => toggleDetalhes(idx, p.periodo)}
                                style={{ backgroundColor: '#f8f9fa' }}
                            >
                                <div className="d-flex align-items-center gap-2 gap-md-3 flex-wrap">
                                    <div>
                                        <span className="fw-bold fs-6 d-block" style={{ color: '#2c3e50' }}>
                                            Período: <strong style={{ color: '#8b0000' }}>{p.periodo.slice(0, 2)}/{p.periodo.slice(2)}</strong>
                                        </span>
                                        <small style={{ color: '#6c757d', fontWeight: 500, fontSize: '0.8rem' }}>
                                            ({p.inicio} até {p.fim})
                                        </small>
                                    </div>
                                    <div className="mt-1 mt-md-0">
                                        <span className="badge bg-white text-dark border px-2 py-1 px-md-3 py-md-2 shadow-sm">
                                            Utilizado: <strong style={{ color: '#c0392b' }} className="fs-6 ms-1">{formatCurrency(p.conv_valorconvenio)}</strong>
                                        </span>
                                    </div>
                                </div>

                                <button 
                                    type="button" 
                                    className="btn btn-sm btn-outline-danger fw-bold d-flex align-items-center gap-1"
                                >
                                    {detalhesVisiveis[idx] ? (
                                        <><span>Ocultar</span> <FaChevronUp /></>
                                    ) : (
                                        <><span>Detalhes</span> <FaChevronDown /></>
                                    )}
                                </button>
                            </div>

                            {detalhesVisiveis[idx] && (
                                <div className="card-body border-top p-2 p-md-0 bg-white">
                                    {detalhesVisiveis[idx].length === 0 ? (
                                        <div className="p-3 text-center text-muted small">
                                            Nenhuma compra registrada neste período.
                                        </div>
                                    ) : (
                                        <>
                                            {/* 🖥️ VISÃO DESKTOP (Tabela Tradicional) */}
                                            <div className="d-none d-md-block">
                                                <table className="table table-hover align-middle m-0 small">
                                                    <thead className="table-light">
                                                        <tr>
                                                            <th className="text-center py-2">Data/Hora</th>
                                                            <th className="text-start py-2">Loja</th>
                                                            <th className="text-center py-2">Nota</th>
                                                            <th className="text-center py-2">Série</th>
                                                            <th className="text-end py-2">Valor Compra</th>
                                                            <th className="text-end py-2">Valor Convênio</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {detalhesVisiveis[idx].map((c, i) => (
                                                            <tr key={i}>
                                                                <td className="text-center text-nowrap">{c.conv_datavenda} {c.conv_hora}</td>
                                                                <td className="text-start fw-semibold text-secondary">{c.conv_loja}</td>
                                                                <td className="text-center">
                                                                    <button
                                                                        className="btn btn-sm btn-outline-danger py-0 px-2"
                                                                        style={{ fontSize: '0.78rem' }}
                                                                        onClick={() => window.open(
                                                                            `https://consultadfe.fazenda.rj.gov.br/consultaNFCe/QRCode?p=${c.conv_idnfe}|2|1|3|525D610DB9E208DBFE0D0DF74667DED2118E24CB`,
                                                                            '_blank'
                                                                        )}
                                                                    >
                                                                        {c.conv_nota}
                                                                    </button>
                                                                </td>
                                                                <td className="text-center">{c.conv_serie}</td>
                                                                <td className="text-end">{formatCurrency(c.conv_valorcompra)}</td>
                                                                <td className="text-end fw-bold text-danger">{formatCurrency(c.conv_valorconvenio)}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>

                                            {/* 📱 VISÃO MOBILE (Cards sem Scroll Lateral) */}
                                            <div className="d-md-none p-1">
                                                {detalhesVisiveis[idx].map((c, i) => (
                                                    <div key={i} className="convenio-mobile-card p-2.5 mb-2 rounded border bg-light">
                                                        <div className="d-flex justify-content-between align-items-center mb-1">
                                                            <span className="fw-bold text-dark small">
                                                                Loja {c.conv_loja}
                                                            </span>
                                                            <button
                                                                className="btn btn-xs btn-outline-danger py-0 px-2 fw-bold d-flex align-items-center gap-1"
                                                                style={{ fontSize: '0.75rem' }}
                                                                onClick={() => window.open(
                                                                    `https://consultadfe.fazenda.rj.gov.br/consultaNFCe/QRCode?p=${c.conv_idnfe}|2|1|3|525D610DB9E208DBFE0D0DF74667DED2118E24CB`,
                                                                    '_blank'
                                                                )}
                                                            >
                                                                <FaReceipt size={10} /> Nota: {c.conv_nota}
                                                            </button>
                                                        </div>

                                                        <div className="d-flex justify-content-between align-items-center text-muted extra-small mb-2">
                                                            <span>📅 {c.conv_datavenda} {c.conv_hora}</span>
                                                            <span>Série: {c.conv_serie}</span>
                                                        </div>

                                                        <div className="d-flex justify-content-between align-items-center pt-1 border-top">
                                                            <span className="extra-small text-secondary">
                                                                Compra: <strong>{formatCurrency(c.conv_valorcompra)}</strong>
                                                            </span>
                                                            <span className="small fw-bold text-danger">
                                                                Convênio: {formatCurrency(c.conv_valorconvenio)}
                                                            </span>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </>
                                    )}
                                </div>
                            )}
                        </div>
                    ))
                )}
            </div>

            <Footer />
        </div>
    );
};

export default Convenio;